export const transformCourseData = (apiData) => {
  const transformedData = {};

  // Iterate through each program (BBA, CSE, ITM, etc.)
  Object.keys(apiData).forEach((programKey) => {
    const programData = apiData[programKey];
    const courseMaps = programData.course_maps || [];
    const sections = [];

    console.log(programData);
    

    // Create Course Map section first
    const courseMapSection = {
      id: `course-map-${programKey.toLowerCase()}`,
      title: "Course Map",
      subtitles: [
        `List of Course Category to Complete ${programKey}`,
        // // Calculate total credits from all course maps
        // `Total Credits: ${courseMaps.reduce((total, courseMapData) => {
        //   return total + parseInt(courseMapData.courseMap.total_credits);
        // }, 0)}`,
        // Calculate total credits from all course maps
        `Total Credits: ${programData.credits}`,
      ],
      courses: courseMaps.map((courseMapData, index) => ({
        sno: index + 1,
        area: courseMapData.courseMap.area,
        noOfCourse: courseMapData.courseMap.number_of_courses.toString(),
        credits: parseInt(courseMapData.courseMap.total_credits),
      })),
    };
    sections.push(courseMapSection);

    // Create individual course sections
    courseMaps.forEach((courseMapData) => {
      const { courseMap, courses } = courseMapData;

      const section = {
        id: `${courseMap.area
          .toLowerCase()
          .replace(/\s+/g, "-")}-${programKey.toLowerCase()}`,
        title: courseMap.area,
        subtitles: [
          `${courseMap.number_of_courses} Courses`,
          `${courseMap.total_credits} Credits`,
        ],
        courses: courses.map((course, index) => ({
          sno: index + 1,
          code: course.code,
          name: course.name,
          credits: course.credit,
        })),
      };

      sections.push(section);
    });

    // Add to transformed data
    transformedData[Object.keys(transformedData).length.toString()] = {
      name: programKey,
      sections: sections,
    };
  });

  return transformedData;
};
